import { combineReducers } from 'redux';
import menu from './app.menu';
import flash from './flash';

export default combineReducers({
    menu,
    flash
});
